/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';
import type { GetPaymentByUserIdRequestLimit } from './GetPaymentByUserIdRequestLimit';
import {
    GetPaymentByUserIdRequestLimitFromJSON,
    GetPaymentByUserIdRequestLimitFromJSONTyped,
    GetPaymentByUserIdRequestLimitToJSON,
    GetPaymentByUserIdRequestLimitToJSONTyped,
} from './GetPaymentByUserIdRequestLimit';

/**
 * 
 * @export
 * @interface GetPaymentByUserIdRequest
 */
export interface GetPaymentByUserIdRequest {
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof GetPaymentByUserIdRequest
     */
    studentId: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {GetPaymentByUserIdRequestLimit}
     * @memberof GetPaymentByUserIdRequest
     */
    limit?: GetPaymentByUserIdRequestLimit | null;
}

/**
 * Check if a given object implements the GetPaymentByUserIdRequest interface.
 */
export function instanceOfGetPaymentByUserIdRequest(value: object): value is GetPaymentByUserIdRequest {
    if (!('studentId' in value) || value['studentId'] === undefined) return false;
    return true;
}

export function GetPaymentByUserIdRequestFromJSON(json: any): GetPaymentByUserIdRequest {
    return GetPaymentByUserIdRequestFromJSONTyped(json, false);
}

export function GetPaymentByUserIdRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPaymentByUserIdRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'studentId': ActorActivityRecordActorUserIdFromJSON(json['studentId']),
        'limit': json['limit'] == null ? undefined : GetPaymentByUserIdRequestLimitFromJSON(json['limit']),
    };
}

export function GetPaymentByUserIdRequestToJSON(json: any): GetPaymentByUserIdRequest {
    return GetPaymentByUserIdRequestToJSONTyped(json, false);
}

export function GetPaymentByUserIdRequestToJSONTyped(value?: GetPaymentByUserIdRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'studentId': ActorActivityRecordActorUserIdToJSON(value['studentId']),
        'limit': GetPaymentByUserIdRequestLimitToJSON(value['limit']),
    };
}

